import { render, staticRenderFns } from "./reactivosVariasRespuestas.vue?vue&type=template&id=75a30e33&scoped=true&"
import script from "./reactivosVariasRespuestas.vue?vue&type=script&lang=js&"
export * from "./reactivosVariasRespuestas.vue?vue&type=script&lang=js&"
import style0 from "./reactivosVariasRespuestas.vue?vue&type=style&index=0&id=75a30e33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a30e33",
  null
  
)

export default component.exports